export enum ERefundType{
    Free='Free',
    Paid='Paid',
    PreStay='PreStay',
    Impossible='Impossible'
}